<template>
  <div class="container">
    <div class="row mb-3">
      <div class="col-12">
        <h1>About OSRS Genie</h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h1 class="mb-3">Who Am I?</h1>

            <p>Hi all! My name is Scott, a fellow scaper and software engineer. for anyone interested in how this
              website came to be and the motivation behind it please read on!</p>

            <p>Like many others i started playing runescape back in 2003/2004 however had very little knowledge of the
              game and quit just after the evolution of combat (RS3). Life moved on and i moved to other games such as
              World of Warcraft and League of Legends.</p>

            <p>Upon completing school i went straight into software development and honed my skills, later on hearing
              that OSRS had been released, this kicked off all the nostalgic memories of playing runescape and with that
              i jumped back in and decided to build OSRS-Genie as a way of helping me get back into the game</p>

            <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/misc/time_played.PNG"
                 alt="Time played" title="Time played">
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h1 class="mb-4">What is OSRS Genie</h1>

            <p>
              OSRSGenie was built as a way of giving back to the community. over the years i have enjoyed tonnes of free
              content from many runescape players. Upon returning to OSRS after a long break i realised how hard it was
              to
              work out the optimal setups for bosses, dps, farm runs etc.
            </p>

            <p>This is where OSRS Genie comes in. This website aims to provide the most accurate and up-to-date
              information
              about OSRS to aid players in finding upgrades, DPS improvements and speed up boss kills.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="col-12">
              <h2>Get In Touch</h2>
              <p>Got an idea, found a bug or just want a chat? let us know below!</p>
            </div>

            <div class="col-12 mt-3">
              <form name="contact"
                    class="form"
                    method="post"
                    data-netlify="true"
                    data-netlify-honeypot="bot-field"
                    @submit.prevent="handleSubmit"
                    netlify
              >

                <div class="form-group row">
                  <label for="name" class="col-sm-2 col-form-label">Name</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" name="name" id="name" v-model="form.name"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="email" class="col-sm-2 col-form-label">Email</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="email" name="email" id="email" v-model="form.email"/>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="message" class="col-sm-2 col-form-label">Message</label>
                  <div class="col-sm-10">
                    <textarea class="form-control" name="message" id="message" v-model="form.message"></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-6 offset-4">
                    <button class="btn btn-primary btn-block" type="submit">Send</button>
                  </div>
                </div>


              </form>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "About",
    data() {
      return {
        form: {
          name: '',
          email: '',
          message: '',
        },
      }
    },
    methods: {
      encode(data) {
        return Object.keys(data)
          .map(
            key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
          )
          .join("&");
      },
      handleSubmit: function () {
        const axiosConfig = {
          header: {"Content-Type": "application/x-www-form-urlencoded"}
        };
        this.$http.post(
          "/",
          this.encode({
            "form-name": "contact",
            ...this.form
          }),
          axiosConfig
        ).then((resp) => {
          console.log(resp);
          this.$toasted.show('Thanks for getting in touch!', {duration: 5000})
        });
      },
    }
  }
</script>

<style scoped>
  .card {
    border-color: #3F3529;
  }

  .card-body {
    color: black;
    font-size: 1.3rem;
    background: #5B5545;
  }

  .form-control, .form-control:focus {
    color: black;
    background: #dbcba3;
    border: 3px solid #5B5545;
  }

  .form-control:disabled, .form-control[readonly] {
    /*background-color: #e9ecef;*/
    background: #5B5545;
  }
</style>



// WEBPACK FOOTER //
// src/pages/About.vue